<input #searchBox
    type="search"
    aria-label="search"
    placeholder="Search"
    (input)="doSearch()"
    (keyup)="doSearch()"
    (focus)="doFocus()"
    (click)="doSearch()">


// WEBPACK FOOTER //
// /home/wzc/dev/angular/angular/aio/src/app/search/search-box/search-box.component.ts.SearchBoxComponent.html